<div class="wrapper">
	<div class="text-container">
		<ion-row class="ion-align-items-start">
			<ion-col>
				<h3>{{ 'order.note.header' | translate }}</h3>
			</ion-col>
			<ion-icon (click)="dismiss()" name="close" size="large" src="../../../assets/icon/cross.svg"></ion-icon>
		</ion-row>
		<ion-row>
			<ion-col>
				<ion-textarea
					[(ngModel)]="inputNote"
					cols="10"
					placeholder="{{ 'order.note.placeholder' | translate }}"
					rows="4"
				></ion-textarea>
			</ion-col>
		</ion-row>
	</div>
	<ion-row>
		<ion-col class="button-block">
			<ion-button (click)="dismiss()" class="button button-block_dismiss">
				{{ 'order.note.cancel' | translate }}
			</ion-button>
			<ion-button (click)="addNote()" class="button button-block_add">
				{{ 'order.note.ok' | translate }}
			</ion-button>
		</ion-col>
	</ion-row>
</div>
